export default __webpack_public_path__ + "static/media/credit_card_black.750afe7a.png";